import React from 'react';
import config from 'appconfig';
import { FormattedMessage } from 'react-intl';
import SectionMessage from '@atlaskit/section-message';
import { ModalTransition } from '@atlaskit/modal-dialog';

import { messages } from 'modules/mac/messages';
import { PromotionContent } from './PromotionContent';
import Link from 'components/common/Link';
import t from 'modules/i18n/intl';

export const MakePrimaryModal = ({
  closeModal,
  contactId,
  accountId,
  contactRelationshipType,
  email,
  handlePromotion,
  succeed,
  promotionError,
}) =>
  !!contactRelationshipType && (
    <ModalTransition>
      <PromotionContent
        kind={contactRelationshipType}
        email={email}
        accountId={accountId}
        onCancel={closeModal}
        onConfirm={() => {
          handlePromotion(contactRelationshipType);
          setTimeout(closeModal, 1000);
        }}
        extraMessage={
          succeed ? (
            <SectionMessage appearance="success">
              <FormattedMessage
                {...messages.promotionSucceed}
                values={{
                  email,
                  kind: t(`mac.licenses.${contactRelationshipType}.promotion`),
                  id: contactId,
                }}
              />
            </SectionMessage>
          ) : (
            <>
              {promotionError === 'irreconcilable' && (
                <SectionMessage appearance="error">
                  <FormattedMessage
                    {...messages.promotionIrreconcilable}
                    values={{
                      link: (
                        <Link to={config.companyContact}>
                          <FormattedMessage {...messages.makePrimaryContactUs} />
                        </Link>
                      ),
                    }}
                  />
                </SectionMessage>
              )}
              {promotionError === 'irreconcilable' && (
                <SectionMessage appearance="error">
                  <FormattedMessage
                    {...messages.promotionFailed}
                    values={{
                      email,
                      kind: contactRelationshipType,
                      id: accountId,
                    }}
                  />
                </SectionMessage>
              )}
            </>
          )
        }
      />
    </ModalTransition>
  );
